/*
This file is where we put common keys used by useGenericState. 

Note: Keys do not really need to be here if not commonly used. This file is for global keys only
Developers can create keys inside specific components if keys are not widely used (local for that component only). 
In that way, if the component is decided to be code split, it goes together with the key inside it.
*/
import {maxLengthText, pagingOptions} from '../../../util/uiconstants';
import {labels} from '../../../util/utils';
export const FETCH_FILTERS = 'fetchFilters';
export const LOADER = 'loader';
export const CURRENT_VIEW = 'currentView';
export const GO_TO_SOURCE = 'goToSource';
export const CURRENT_STATE_FOR_DRAWER = 'currentStateForDrawer';
export const CURRENT_COMMENT_STATE_KEY = 'currentCommentStateKey';
export const COMMENTS_COUNT = 'commentsCount';
export const NAVIGATION_SECTION_ICONS = 'navigationSectionIcons';
export const CURRENT_COMMENT_MODAL_CONFIG = 'currentCommentModalConfig';
export const CURRENT_PILL_COMMENTS_IS_ACTIVE = 'currentPillCommentsIsActive';
export const CURRENT_PILL_VALIDATION_IS_ACTIVE = 'currentPillValidationIsActive';
export const CURRENT_PILL_GUIDANCE_IS_ACTIVE = 'currentPillGuidanceIsActive';
export const IS_BODY_SPECIAL_DATA_UPDATED = 'isBodySpecialDataUpdated';
export const LIST_STATE_NAME_LIST = 'listStateNameList';
export const UPDATE_ON_MODAL_HAPPENED = 'updateOnModalHappened';
export const UNRELATED_TASK_CONFIG = 'unrelatedTaskConfig';
export const FETCH_FILTERS_DEFAULT_VALUES = {
	searchstring: null,
	page: 1,
	pagesize: pagingOptions.defaultPageSize,
	pages: 1,
	includePagination: true,
	orderBy: null,
	orderByAscending: true,
	isinitializefetch: false,
	showAddedOnly: false,
	isLoading: false,
	defaultNoDataMessage: '',
	filterRelatedTask: null,
	showValidations: false,
	validationTypeIds: []
};
export const DEFAULT_COMMENTS_STATE = {
	config: {},
	commentStatuses: {},
	filters: undefined,
	selectedCommentGuid: undefined,
	modalConfig: undefined
};

export const COMMENTS_IS_ACTIVE_DEFAULT_DATA = {
	bodyId: null,
	documentTypeId: null
};
export const VALIDATION_IS_ACTIVE_DEFAULT_DATA = {
	documentId: null,
	headerId: null,
	sectionId: null,
	bodyId: null,
	displayFor: null
};
export const getRelateModalConfiguration = () => ({
	searchLabel: labels.searchPlaceholder,
	searchMaxLength: maxLengthText.maxLength100,
	isLoading: false,
	showOnlyRelatedLabel: labels.showOnlyRelated,
	countsLabel: labels.taskCountPlural,
	countLabel: labels.taskCountSingular,
	addedLabel: labels.added,
	closeButtonLabel: labels.modalCloseTitle,
	noResultFound: labels.noResultsAvailable,
	clearHoverText: labels.clear,
	modalHeader: '',
	selectedSectionLabel: '',
	selectedSectionValue: '',
	taskHeaderColumnName: labels.task,
	listStateName: '',
	searchStateName: '',
	filterStateName: '',
	currentTaskTypeId: null,
	currentSectionId: null,
	typeHeaderColumnName: labels.type,
	showTaskStatus: false
});
